<template>
  <div
    v-click-outside="onClickOutside"
    :class="{ 'form-checkbox-multi-select__disabled': disabled, 'form-checkbox-multi-select__active': showOptionsMenu }"
    class="form-checkbox-multi-select"
    @click.stop="!disabled ? (showOptionsMenu = !showOptionsMenu) : () => {}"
  >
    <div class="upper-label">{{ label }}</div>
    <div v-if="value.length > 0" class="value-label">{{ renderValueLabel(optionList) }}</div>
    <div v-if="value.length === 0" class="value-label">Не выбрано</div>
    <div v-if="showOptionsMenu" class="multi-select-content" @click.stop>
      <slot v-if="!!$slots['option-list']" name="option-list" :option-list="optionList" />
      <ul v-else>
        <template v-if="Array.isArray(optionList) && optionList.length > 0">
          <li v-for="(option, index) in optionList" :key="index">
            <FormCheckbox :label="option.text" :checked="value.indexOf(option.value) > -1" @click="onSelectOption(option)" />
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import NewFormCheckbox from "../../../components/forms/NewFormCheckbox";

export default {
  name: "FormChekcboxMultiSelect",
  components: {
    FormCheckbox: NewFormCheckbox
  },
  props: {
    fieldname: {
      type: String,
      default: ""
    },
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    renderValueLabel: {
      type: Function,
      default: optionList => {
        return (
          optionList
            .filter(item => item.selected === true)
            .map(item => item.value)
            .join(", ") + " класс"
        );
      }
    }
  },
  data() {
    return {
      showOptionsMenu: false,
      changed: false,
      optionList: []
    };
  },
  mounted() {
    this.optionList = [...this.options].map(option => ({
      ...option,
      selected: this.value.findIndex(item => item === option.value) > -1 ? true : false
    }));
  },
  methods: {
    onClickOutside() {
      if (this.showOptionsMenu === true) {
        this.showOptionsMenu = false;

        this.$nextTick(() => {
          this.$emit("hide-option-menu", {
            value: this.value,
            changed: this.changed,
            fieldname: this.fieldname
          });
          this.changed = false;
        });
      }
    },
    onSelectOption(selectedOption) {
      const index = this.optionList.findIndex(item => item.value === selectedOption.value);

      if (index !== -1) {
        this.changed = true;

        if (this.optionList[index].selected === true) {
          this.optionList[index] = { ...selectedOption, selected: !this.optionList[index].selected };

          this.$emit("change", {
            value: this.optionList.filter(item => item.selected === true).map(item => item.value),
            fieldname: this.fieldname
          });
        } else {
          this.optionList[index] = { ...selectedOption, selected: !this.optionList[index].selected };

          this.$emit("change", {
            value: this.optionList.filter(item => item.selected === true).map(item => item.value),
            fieldname: this.fieldname
          });
        }
      }
    }
  }
};
</script>
